<template>
    <div class="news">
        <banner title="新闻资讯" />
        <div class="aboutUs-box" v-if="web_view == 'web'">
            <div class="safe-box">
                
                <div class="aboutUs-section" v-if="isNav == '1'">
                    <h2 class="common-title">经营品类</h2>
                    <h4 class="common-ctitle">Line of business</h4>
                    <div class="info">心诚直销商城已完成超过20个大类产品 20000 余个 SKU 商品的供应链管理。对 70000 余个车型进行了数据解析，数据处理已达数亿条！未来还有增加更多大项，更多的SKU。</div>
                    <div class="info">机油、波箱油、柴机油、火花塞、雨刮片、滤清器、刹车片、喇叭、皮带、机脚胶、球头、摆臂、顶胶、减振、拉杆、防冻液、点火线圈、氧传感器、车灯、制动液、养护用品、.........</div>
                    <img class="nav-img" v-if="cnav == '1'" src="@/assets/img/product/nav1.png" />
                    <img class="nav-img" v-if="cnav == '2'" src="@/assets/img/product/nav2.png" />
                    <img class="nav-img" v-if="cnav == '3'" src="@/assets/img/product/nav3.png" />
                    <div class="cnav-item">
                        <a :class="cnav == '1'?'nav-item-on':''" @click="nav(1)"></a>
                        <a :class="cnav == '2'?'nav-item-on':''" @click="nav(2)"></a>
                        <a :class="cnav == '3'?'nav-item-on':''" @click="nav(3)"></a>
                    </div>
                </div>
                <div class="aboutUs-section" v-if="isNav == '2'">
                    <h2 class="common-title">养车工厂店</h2>
                    <h4 class="common-ctitle">Car maintenance shop</h4>
                    <img class="nav-img" v-if="dnav == '1'" src="@/assets/img/product/nav4.png" />
                    <img class="nav-img" v-if="dnav == '2'" src="@/assets/img/product/nav5.png" />
                    <img class="nav-img" v-if="dnav == '3'" src="@/assets/img/product/nav6.png" />
                    <img class="nav-img" v-if="dnav == '4'" src="@/assets/img/product/nav7.png" />
                    <div class="cnav-item">
                        <a :class="dnav == '1'?'nav-item-on':''" @click="nav_car(1)"></a>
                        <a :class="dnav == '2'?'nav-item-on':''" @click="nav_car(2)"></a>
                        <a :class="dnav == '3'?'nav-item-on':''" @click="nav_car(3)"></a>
                        <a :class="dnav == '4'?'nav-item-on':''" @click="nav_car(4)"></a>
                    </div>
                </div>
                <div class="aboutUs-section" v-if="isNav == '3'">                   
                    <h2 class="common-title">云仓分布</h2>
                    <h4 class="common-ctitle">Site  distribution</h4>
                    <img class="nav-img" src="@/assets/img/product/nav8.png" />
                    <img class="nav-img" src="@/assets/img/product/nav9.png" />
                    <img class="nav-img" src="@/assets/img/product/nav10.png" />
                    <img class="nav-img" src="@/assets/img/product/nav11.png" />
                    <img class="nav-img" src="@/assets/img/product/nav12.png" />  
                    <img class="nav-img" src="@/assets/img/product/nav13.png" />                   
                </div>
            </div>
        </div>
        <div class="aboutUs-box" v-if="web_view == 'h5'">
            <div class="safe-box-h5">
                
                <div class="aboutUs-section-h5" v-if="isNav == '1'">
                    <h2 class="common-title-h5">经营品类</h2>
                    <h4 class="common-ctitle-h5">Line of business</h4>
                    <div class="info">心诚直销商城已完成超过20个大类产品 20000 余个 SKU 商品的供应链管理。对 70000 余个车型进行了数据解析，数据处理已达数亿条！未来还有增加更多大项，更多的SKU。</div>
                    <div class="info">机油、波箱油、柴机油、火花塞、雨刮片、滤清器、刹车片、喇叭、皮带、机脚胶、球头、摆臂、顶胶、减振、拉杆、防冻液、点火线圈、氧传感器、车灯、制动液、养护用品、.........</div>
                    <img class="nav-img-h5" v-if="cnav == '1'" src="@/assets/img/product/nav1.png" />
                    <img class="nav-img-h5" v-if="cnav == '2'" src="@/assets/img/product/nav2.png" />
                    <img class="nav-img-h5" v-if="cnav == '3'" src="@/assets/img/product/nav3.png" />
                    <div class="cnav-item">
                        <a :class="cnav == '1'?'nav-item-on':''" @click="nav(1)"></a>
                        <a :class="cnav == '2'?'nav-item-on':''" @click="nav(2)"></a>
                        <a :class="cnav == '3'?'nav-item-on':''" @click="nav(3)"></a>
                    </div>
                </div>
                <div class="aboutUs-section-h5" v-if="isNav == '2'">
                    <h2 class="common-title-h5">养车工厂店</h2>
                    <h4 class="common-ctitle-h5">Car maintenance shop</h4>
                    <img class="nav-img-h5" v-if="dnav == '1'" src="@/assets/img/product/nav4.png" />
                    <img class="nav-img-h5" v-if="dnav == '2'" src="@/assets/img/product/nav5.png" />
                    <img class="nav-img-h5" v-if="dnav == '3'" src="@/assets/img/product/nav6.png" />
                    <img class="nav-img-h5" v-if="dnav == '4'" src="@/assets/img/product/nav7.png" />
                    <div class="cnav-item">
                        <a :class="dnav == '1'?'nav-item-on':''" @click="nav_car(1)"></a>
                        <a :class="dnav == '2'?'nav-item-on':''" @click="nav_car(2)"></a>
                        <a :class="dnav == '3'?'nav-item-on':''" @click="nav_car(3)"></a>
                        <a :class="dnav == '4'?'nav-item-on':''" @click="nav_car(4)"></a>
                    </div>
                </div>
                <div class="aboutUs-section-h5" v-if="isNav == '3'">                   
                    <h2 class="common-title-h5">云仓分布</h2>
                    <h4 class="common-ctitle-h5">Site  distribution</h4>
                    <img class="nav-img-h5" src="@/assets/img/product/nav8.png" />
                    <img class="nav-img-h5" src="@/assets/img/product/nav9.png" />
                    <img class="nav-img-h5" src="@/assets/img/product/nav10.png" />
                    <img class="nav-img-h5" src="@/assets/img/product/nav11.png" />
                    <img class="nav-img-h5" src="@/assets/img/product/nav12.png" />  
                    <img class="nav-img-h5" src="@/assets/img/product/nav13.png" />                   
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Banner from "../components/Banner3";
export default {
    name: "news",
    components: {
        Banner,
    },
    data() {
        return {
            web_view:"", // 视图窗口模式 900px以下是手机，以上是PC
            isNav:"3",
            cnav:"1",
            dnav:"1",
            loading: true,
            newsList: [],
            newstype: 1,
        };
    },
    created(){
        console.log("2222")
    },
    mounted(){
        let that = this
        if(parseFloat(document.body.clientWidth) < 900){
            this.web_view = 'h5'
            console.log("this.web_view",this.web_view)
        }else{
            this.web_view = 'web'
            console.log("this.web_view",this.web_view)
        }
        window.addEventListener('resize', function() {// 变化后需要做的事
            if(parseFloat(document.body.clientWidth) < 900){
                this.web_view = 'h5'
                console.log("this.web_view",this.web_view)
            }else{
                this.web_view = 'web'
                console.log("this.web_view",this.web_view)
            }
            that.$forceUpdate()
        })
    },
    methods: {
        nav(e){
            this.cnav = e
        },
        nav_car(e){
            this.dnav = e
        },
    },
    watch: {

    },
};
</script>

<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
}
.news {
    width: 100%;
    height: 100%;
    background-color: #333333;
    position: relative;
    overflow: hidden;

    &-section {
        width: 100%;
        //height: 1600px;

        &-content {
            width: 1240px;
            //height: 1600px;
            margin: 0 auto;
            background-color: #fff;
            border: 1px solid red;

            .content-nav {
                width: 400px;
                height: 55px;
                margin: 0 auto;
                display: flex;
                //justify-content: center;
                align-items: center;
                position: relative;
                bottom: 30px;
                border: 1px solid red;

                &-btn {
                    width: 50%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #e4e4e4;
                    transition: all 0.2s;
                }

                .content-nav-active {
                    background-color: red;
                    color: #fff;
                }
            }

            .content-nav-item {
                width: 1070px;
                margin: 0 auto;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                //border: 1px solid blue;

                .item-list {
                    width: 330px;
                    height: 500px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    margin: 10px 10px;
                    border: 1px solid #15669e;

                    &:hover {
                        border: 1px solid #fff;
                        box-shadow: 0 0 5px 2px #bfd3e0;
                    }
                    .item-img {
                        width: 300px;
                        height: 210px;
                        background-color: #cecece;
                        background-repeat: no-repeat;
                        background-size: cover;
                        background-position: center;
                        background-origin: content-box;
                    }

                    &-title {
                        width: 300px;
                        height: 60px;
                        color: #15669e;
                        font-size: 22px;
                        padding: 0 10px;
                        margin: 20px 0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        border-left: 1px solid #15669e;
                    }

                    &-content {
                        width: 273px;
                        height: 100px;
                        font-size: 14px;
                        color: gray;

                        // 文本长度处理 begin
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 5;
                        -webkit-box-orient: vertical;
                        white-space: normal !important;
                        word-wrap: break-word;
                        // 文本长度处理 ending
                    }

                    &-more {
                        width: 273px;
                        padding-top: 20px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;

                        img {
                            width: 12px;
                            height: 12px;
                        }
                        span {
                            color: #e13834;
                            padding: 0 5px;
                        }
                    }
                }
            }
        }
    }
    .text-decoration {
        text-decoration: none;
    }
}
.aboutUs-box {
    background: #333;
}
.safe-box {
    width: 1400px;
    margin: auto;
}
.cnav-item {
    width:150px;
    height: 30px;
    margin: auto;  
    margin-top: 40px;
    margin-bottom: 20px;
}
.cnav-item a{
    width:30px;
    height: 30px;
    border-radius: 50%;
    box-sizing: border-box;
    border: 1px solid #fff;
    text-align: center;
    float: left;
    color: #fff;
    margin: 0 10px;
    cursor: pointer;
}

.nav-item-on {
    background: red !important;
    border: 1px solid red !important;
    color: #fff;
}
.aboutUs-section {
    width: 960px;
    margin: auto;
    text-align: center;
}
.aboutUs-section .info {
    color: #fff;
    text-indent:32px;
    line-height: 40px;
    font-size: 18px;
    text-align: justify;
    margin-bottom: 10px;
}
.nav-img {
    width: 967px;
    margin: 40px 0;
}
.nav-img2 {
    width: 956px;
    margin: 40px 0;
}
.nav-img3 {
    width: 921px;
    margin: 30px 0;
}
.nav-img4 {
    width: 950px;
    margin: 30px 0;
    margin-left: 30px;
}
.nav-img5 {
    width: 1200px;
    margin: 30px 0;
}
.nav-img6 {
    margin: 40px 0;
}
.common-title {
    font-size: 36px;
    color: #fff;
    margin-top: 45px;
    margin-bottom: 20px;
    letter-spacing: 4px;
    font-weight: 500;
}
.common-ctitle {
    font-size: 16px;
    color: #fff;
    margin-bottom: 40px;
    font-weight: 500;
}

.safe-box-h5 {
    width: 100%;
    margin: auto;
    padding: 10px;
    box-sizing: border-box;
}
.common-title-h5 {
    font-size: 18px;
    color: #fff;
    margin-top: 4px;
    margin-bottom: 10px;
    letter-spacing: 4px;
    font-weight: 500;
}
.common-ctitle-h5 {
    font-size: 12px;
    color: #fff;
    margin-bottom: 10px;
    font-weight: 500;
}
.aboutUs-section-h5 {
    width: 100%;
    margin: auto;
    text-align: center;
}
.aboutUs-section-h5 .info {
    color: #fff;
    text-indent: 35px;
    line-height: 28px;
    font-size: 14px;
    text-align: justify;
    margin-bottom: 10px;
}
.nav-img-h5 {
    width: 100%;
    margin: 10px 0;
}
</style>
